import { gql } from '../__generated__/gql';

const SEARCH_LOCATIONS = gql(`
  query SearchLocations(
    $orderBy: [LocationOrderByWithRelationInput!]
    $skip: Int
    $take: Int
    $where: LocationWhereInput
  ) {
    locations(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
      id
      name
    }
  }
`);

export default SEARCH_LOCATIONS;
